export default {
    getLoader: state => state.loader,
    getLoaderMessage: state => state.loaderMessage,
    getAllFoundationsTab: state => state.allFoundationsTab,
}
